const analytics = () => {
    // Google Tag Manager
    if (window.gtmId && window.gtmId !== '') {
        // Initialize dataLayer if it doesn't exist
        window.dataLayer = window.dataLayer || [];
        
        (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
            const f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
            j.async = true;
            j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', window.gtmId);
    }

    // Set global variables if they exist
    if (window.recaptchaKey) {
        window.recaptchaKey = window.recaptchaKey;
    }
    
    if (window.facebookClientID) {
        window.facebookClientID = window.facebookClientID;
        window.facebookScope = window.facebookScope;
    }
    
    if (window.siteUrl) {
        window.siteUrl = window.siteUrl;
    }
};

export default analytics;
